import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/authContext';
import { getSubscriptionStatus, getRecipeQuota, formatQuotaText } from '../services/subscriptionService';

const RecipeQuotaBadge = ({ className = '' }) => {
    const { user } = useAuth();
    const [subscription, setSubscription] = useState(null);
    const [quotaInfo, setQuotaInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Only fetch if user has a profile (is registered in database)
        if (!user || !user.profile) {
            setLoading(false);
            return;
        }

        const fetchQuotaData = async () => {
            try {
                const [subscriptionData, quotaData] = await Promise.all([
                    getSubscriptionStatus(),
                    getRecipeQuota()
                ]);
                // Services now return null instead of throwing when no user
                if (subscriptionData && quotaData) {
                    setSubscription(subscriptionData);
                    setQuotaInfo(quotaData);
                } else {
                    setSubscription(null);
                    setQuotaInfo(null);
                }
            } catch (error) {
                // Silently handle errors - services should return null for missing auth
                setSubscription(null);
                setQuotaInfo(null);
            } finally {
                setLoading(false);
            }
        };

        fetchQuotaData();
    }, [user, user?.profile]);

    // All users now have unlimited recipes, so don't show quota badge
    return null;
};

export default RecipeQuotaBadge;

